import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import LeaveCalendar from "../components/employee/LeaveCalendar";
import ViewOneEmployeeRecord from "../components/hr/ViewOneEmployeeRecord";
import ViewOneEmpPerm from "../components/ViewOneEmpPerm";
import { Card, Row, Col, Avatar, Typography, Descriptions, Tag, Divider, Table, Button, Upload, Modal, Form, Input, Select, DatePicker, message, InputNumber, Space } from "antd";
import {
    ArrowLeftOutlined, EditOutlined, CameraOutlined, DownloadOutlined, SaveOutlined, CloseOutlined, PlusOutlined, DeleteOutlined, CalendarOutlined,
    LogoutOutlined,
    SafetyCertificateOutlined
} from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";


export default function ViewEmpDetails({ employee }) {
    const { authData, backUrl } = useContext(AuthContext)

    const [showCalendar, setShowCalendar] = useState(false);
    const [showLeaves, setShowLeaves] = useState(false);
    const [showPermissions, setShowPermissions] = useState(false);

    const closeCalendar = () => setShowCalendar(false);
    const closeLeaves = () => setShowLeaves(false);
    const closePermissions = () => setShowPermissions(false);

    return (
        <>
            <div
                style={{
                    display: "flex",
                    gap: "10px",
                    marginTop: "10px",
                    flexWrap: "wrap",
                    justifyContent: 'space-around',
                    width: '600px'
                }}
            >
                {/* Show Calendar */}
                <Button
                    type="primary"
                    icon={<CalendarOutlined />}
                    onClick={() => setShowCalendar(true)}
                    style={{ backgroundColor: '#0e497b', color: 'white' }}
                >
                    Calendar
                </Button>

                {/* Leaves */}
                <Button
                    type="default"
                    icon={<LogoutOutlined />}
                    onClick={() => setShowLeaves(true)}
                    style={{ backgroundColor: '#0e497b', color: 'white' }}

                >
                    Leaves
                </Button>

                {/* Permissions */}
                <Button
                    type="dashed"
                    icon={<SafetyCertificateOutlined />}
                    onClick={() => setShowPermissions(true)}
                    style={{ backgroundColor: '#0e497b', color: 'white' }}

                >
                    Permissions
                </Button>
            </div>

            <Modal
                title="Calendar"
                open={showCalendar}          // 👈 AntD v5 uses "open"
                onCancel={closeCalendar}
                footer={null}
                width={600}
            >
                <LeaveCalendar employee={employee} />
            </Modal>

            <Modal
                title="Employee Leaves"
                open={showLeaves}
                onCancel={closeLeaves}
                footer={null}
                width={1200}
            >
                <ViewOneEmployeeRecord
                    employee={{
                        id: employee.id,
                        employee: employee, // Wrap the employee data
                        leaves_taken_breakdown: {
                            sick_leave: employee.taken_sick_leave || 0,
                            casual_leave: employee.taken_casual_leave || 0,
                            earned_leave: employee.taken_earned_leave || 0,
                            lop_leave: employee.taken_lop_leave || 0
                        }
                    }}
                    isProfile={false}
                />
            </Modal>

            <Modal
                title="Employee Permissions"
                open={showPermissions}          // 👈 AntD v5 uses "open"
                onCancel={closePermissions}
                footer={null}
                width={1200}
            >
                <ViewOneEmpPerm employee={{
                    id: employee.id,
                    employee: employee, // Wrap the employee data
                    leaves_taken_breakdown: {
                        sick_leave: employee.taken_sick_leave || 0,
                        casual_leave: employee.taken_casual_leave || 0,
                        earned_leave: employee.taken_earned_leave || 0,
                        lop_leave: employee.taken_lop_leave || 0
                    }
                }}
                    isProfile={false} />
            </Modal>

        </>
    )
}